import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface Props {
  isEmojiLoading?: boolean;
  isCommentModal?: boolean;
  isEmojiModal?: boolean;
}

const Emojis = styled.div<Props>`
  position: absolute;
  z-index: var(--z-index-toast);
  overflow: unset !important;

  aside.EmojiPickerReact.epr-main {
    border: 0.5px solid var(--border-primary) !important;
    border-radius: var(--border-radius-12) !important;
    box-shadow: var(--shadow-dropdown) !important;
    margin-top: var(--space-5) !important;
  }
  .EmojiPickerReact {
    background-color: var(--background-primary);
  }
  .EmojiPickerReact .epr-category-nav > button.epr-cat-btn {
    background-image: url(https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/Template_images%2Femoji_svg_ref.svg?alt=media&token=7fd738ed-1e10-4c18-8f91-a0c4b6c7ef5f);
  }
  .epr_-z2fuzw {
    padding: var(--space-4) var(--space-8) !important;
    background-color: var(--background-primary) !important;
    border-radius: var(--border-radius-6) !important;
    border: 0.5px solid var(--border-primary) !important;
    color: var(--text-primary) !important;
    ${Typography.body_sm_medium}
    height: 25px !important;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-label {
    ${Typography.body_xs_semibold}
    height: auto !important;
    padding-block: var(--space-6) !important;
    color: var(--text-secondary) !important;
  }
  .EmojiPickerReact li.epr-emoji-category > .epr-emoji-category-label {
    background-color: var(--background-primary);
  }
  .EmojiPickerReact button.epr-emoji:hover > * {
    border-radius: var(--border-radius-6) !important;
    background-color: var(--neutral-secondary) !important;
  }

  .EmojiPickerReact .epr-search-container input.epr-search::placeholder {
    color: var(--text-placeholder) !important;
  }
  .EmojiPickerReact .epr-body::-webkit-scrollbar-thumb {
    background-color: var(--text-tertiary) !important;
    border-radius: var(--border-radius-6) !important;
    min-height: 20px !important;
  }
  .EmojiPickerReact .epr-search-container input.epr-search:focus {
    border: 0.5px solid var(--brand-primary) !important;
  }
  .epr_jkst5z:focus {
    border-radius: var(--border-radius-6) !important;
    background-color: var(--neutral-secondary) !important;
  }
  .epr_c90x4z {
    display: none;
  }
  ${({ isCommentModal }) =>
    isCommentModal &&
    css`
      position: relative;
      aside.EmojiPickerReact.epr-main {
        border: unset !important;
        border-radius: var(--border-radius-0) !important;
        box-shadow: unset !important;
        margin-top: unset !important;
      }
      .epr_-8ygbw8 {
        padding: var(--space-6) var(--space-6) var(--space-0) var(--space-6) !important;
      }
      .epr_-4ueg5a {
        background-color: unset !important;
      }
      .epr_-to8mm {
        border-color: unset !important;
      }
      .epr_-khp9xq {
        border-radius: var(--border-radius-0) !important;
      }
      .epr_-rvl3je {
        border-style: unset !important;
      }
      .epr_-x928hz {
        border-width: 0 !important;
      }
    `}

  ${(props) =>
    props.isEmojiLoading &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
  ${mobile_xl(css`
    ${(props: Props) =>
      props.isEmojiModal &&
      css`
        position: relative;
        aside.EmojiPickerReact.epr-main {
          border: 0 !important;
          margin-top: var(--space-0) !important;
          width: 100% !important;
        }
      `}
  `)}
`;

export { Emojis };
